import React from 'react';

import styles from './PromoCountriesColumns.module.css';

export const PromoCountriesColumns = (props) => {
    return <ul className={styles.countries}>{props.children}</ul>;
};
